import { render, staticRenderFns } from "./new-lottery-n-ward.vue?vue&type=template&id=0b2250ac&scoped=true&lang=pug&"
import script from "./new-lottery-n-ward.vue?vue&type=script&lang=js&"
export * from "./new-lottery-n-ward.vue?vue&type=script&lang=js&"
import style0 from "./new-lottery-n-ward.vue?vue&type=style&index=0&id=0b2250ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2250ac",
  null
  
)

export default component.exports